import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { addToPlaylistAction, loadUserAction } from "../redux/actions/userAction";
import {BsEyeFill} from 'react-icons/bs'
const CourseCard = ({
  id,
  title,
  description,
  type,
  imgSrc,
  views,
  addToPlaylist,
  createdBy,
  lecture,
}) => {

  const dispatch = useDispatch()

  const courseid = id 
  const addToPlayListHandler = async (courseid) => {
// console.log('add playlist')
    await dispatch(addToPlaylistAction(courseid))
    dispatch(loadUserAction())

  }


  return (
    <div className="flex flex-col lg:flex lg:flex-row mx-auto my-12 items-center bg-brand_jaguar  overflow-hidden">

        {/* flex 1  */}
      <div className="my-8 lg:mx-12 ">
      <img src={imgSrc} alt="" width={"300px"} />
      </div>

      {/* flex 2 */}
      <div className="font-outfit lg:py-6 ">
      
        <h1 className="lg:my-4 text-xl font-semibold uppercase">{title}</h1>
        <h1 className="my-4">{description}</h1>
        <h1 className="my-4 text-sm">{type}</h1>
        <h1 className="my-4 flex items-center gap-2 text-sm">{views} <BsEyeFill/> </h1>

        <h1 className="my-4 text-sm">Creator - {createdBy}</h1>


        <div className="flex text-black justify-start gap-6">
          <Link to={`/course/${courseid}`}>
            <button className="hover:font-bold transition hover:-translate-y-1 py-2 px-4 bg-brand_yellow  my-2">
              Watch Now
            </button>
          </Link>

          <button id={courseid} onClick={()=> {addToPlayListHandler(courseid)}} className="hover:font-bold transition hover:-translate-y-1  py-2 px-4 bg-brand_yellow my-2">Add to My Courses</button>
        </div>
      

      </div>
     
      
    </div>
  );
};

export default CourseCard;
